<!-- 填写物流单号 -->
<template>
<div>
    <el-dialog title="填写发货信息" :visible.sync="dialogVisible" width="750px" 
            :before-close="handleClose" append-to-body>
        <el-form :model="ruleForm" :rules="rules" ref="formRef" label-width="100px">  
            <el-row class="red mg-b-20">注意：如果是第一次发货，请先去添加发件人地址</el-row>
            <el-row>{{ errMsg }}</el-row>           
            <el-row>
                <el-col :span="12">
                    <el-form-item label="发件人姓名" prop="senderName">  
                        <el-input v-model="ruleForm.senderName" placeholder="请输入发件人姓名" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="物流公司" prop="logisticsName">  
                        <el-select v-model="ruleForm.logisticsName" placeholder="请选择物流公司" style="width: 100%;">
                            <el-option v-for="item in lgsCompanyOption"
                                :key="item.value"
                                :value="item.value"
                                :label="item.label"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>               
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="发件人电话" prop="senderPhone">  
                        <el-input v-model="ruleForm.senderPhone" placeholder="请输入发件人电话" ></el-input>
                    </el-form-item>
                </el-col> 
                <el-col :span="12">
                    <el-form-item label="预约日期" prop="reserveDate" >  
                        <el-radio-group v-model="ruleForm.reserveDate" @change="changeReserveDate">
                            <el-radio 
                                v-for="item in reserveDateOption"
                                :label="item.value" 
                                :key="item.label">{{ item.label }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>    
                <el-col :span="12">          
                    <el-form-item label="发件人地址" prop="senderAddress">  
                        <el-select v-model="ruleForm.senderAddress" 
                            placeholder="请选择发件人地址" style="width: 100%;" @change="selectSenderAddress">
                            <el-option 
                                v-for="item in addressOption"
                                :key="item.id"
                                :label="item.senderAddress"
                                :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>  
                </el-col>
                <el-col :span="12">
                    <el-form-item label="预约时间" prop="reserveTime">  
                        <el-select v-model="ruleForm.reserveTime" 
                            placeholder="请选择时间" style="width: 100%;">
                            <el-option v-for="item in filteredTimes"
                                :key="item.value"
                                :value="item.value"
                                :label="item.label"
                                :disabled="item.disabled"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>               
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="重量" prop="weight">  
                        <el-input v-model="ruleForm.weight" placeholder="请输入物品重量" >
                            <template slot="append">KG</template>
                        </el-input>
                    </el-form-item>
                </el-col> 
                <el-col :span="12">
                    <el-form-item label="备注" prop="remark">  
                        <el-input v-model="ruleForm.remark" placeholder="请输入备注" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="收件人姓名" prop="receiverName">  
                        <el-input v-model="ruleForm.receiverName" placeholder="请输入收件人姓名" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="收件人电话" prop="receiverPhone">  
                        <el-input v-model="ruleForm.receiverPhone" placeholder="请输入收件人电话" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="收件人地址" prop="receiverAddress">  
                        <el-input v-model="ruleForm.receiverAddress" placeholder="请输入收件人详细地址" />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="confirmDialog" :disabled="disabled">确定</el-button>
        </span>
    </el-dialog>
</div>
</template>
    
<script lang="">
export default {
    props: {
        formData: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            disabled: false,
            dialogTitle: '',
            dialogVisible: true,
            ruleForm: {
                logisticsName: '',
                senderName: '',
                senderPhone: '',
                senderAddress: '',
                receiverName: '',
                receiverPhone: '',
                receiverAddress: '',
                reserveDate: '今天',
                reserveTime: '',
                weight: null,
                remark: ''
            },
            rules: {
                logisticsName:[
                    { required: true, message: '请输入物流公司', trigger: 'blur' },
                ],  
                senderName :[
                    { required: true, message: '请输入发件人姓名', trigger: 'blur' },
                ], 
                senderPhone: [
                    { required: true, message: '请输入发件人电话', trigger: 'blur' },
                ],
                senderAddress: [
                    { required: true, message: '请输入发件人地址', trigger: 'blur' },
                ],
                receiverName :[
                    { required: true, message: '请输入收件人姓名', trigger: 'blur' },
                ], 
                receiverPhone: [
                    { required: true, message: '请输入收件人电话', trigger: 'blur' },
                ],
                receiverAddress: [
                    { required: true, message: '请输入收件人地址', trigger: 'blur' },
                ],
                reserveDate: [
                    { required: true, message: '请选择预约日期', trigger: 'change' },
                ], 
                reserveTime: [
                    { required: true, message: '请选择预约时间', trigger: 'change' },
                ],
                weight: [
                    { required: true, message: '请输入物品重量', trigger: 'blur' },
                ]  
            },
            lgsCompanyOption: [
                {value: 'jd',label: '京东物流'},
                {value: 'debangkuaidi',label: '德邦快递'},
                {value: 'shunfeng',label: '顺丰速运'},
                {value: 'zhongtong',label: '中通快递'},
                {value: 'shunfengkuaiyun',label: '顺丰快运'},
                {value: 'sxjdfreight',label: '顺心捷达'},
                {value: 'kuayue',label: '跨越速运'},
            ],
            reserveDateOption: [
                {value: '今天',label: '今天'},
                {value: '明天',label: '明天'},
                {value: '后天',label: '后天'},
            ],
            timeSlots: [
                {value: '08:00-10:00', label: '08:00-10:00',disabled: false},
                {value: '10:00-12:00',label: '10:00-12:00',disabled: false},
                {value: '12:00-14:00', label: '12:00-14:00',disabled: false},
                {value: '14:00-16:00',label: '14:00-16:00',disabled: false},
                {value: '16:00-18:00', label: '16:00-18:00',disabled: false},
                {value: '18:00-20:00',label: '18:00-20:00',disabled: false},
            ],
            errMsg: '',
            addressOption: []
        }
    },
    created() {
    
    },
    computed: {
        filteredTimes() {
            const now = new Date();
            const currentHour = now.getHours();
            const currentMinute = now.getMinutes();
            const currentTime = currentHour * 60 + currentMinute; // 转换为分钟数
        
            return this.timeSlots.map(timeSlot => {
                const [start, end] = timeSlot.value.split('-').map(time => {
                const [hour, minute] = time.split(':').map(Number);
                return hour * 60 + minute;
                });
                // 如果是今天，并且当前时间已经超过该时间段的开始时间，则禁用
                const isDisabled = this.ruleForm.reserveDate === '今天' && currentTime >= start;
                
                return {
                    ...timeSlot, // 保留原有的 id、text、value 等属性
                    disabled: isDisabled, // 添加 disabled 属性
                };
            });
            },
    },
    mounted() { 
        // console.log('ok',this.formData)
        let { province,city,district,addressDes,contactName,contactPhone } = this.formData
        this.ruleForm.receiverAddress =  province +''+ city +''+ district +''+ addressDes
        this.ruleForm.receiverName = contactName
        this.ruleForm.receiverPhone = contactPhone
        // console.log(province,city,district,addressDes,contactName,contactPhone)
        // console.log('新的数据',this.ruleForm)
        this.getAddress()
    },
    methods: {
        confirmDialog(){
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    // 校验通过，传递表单数据到父组件
                    this.handleSubmitDelivery()    
                } else {
                    window.scrollTo({
                        top:0,
                        behavior: 'smooth'
                    })
                    console.log('表单校验失败');
                    return false;
                }
            });
        },
        // C端寄件的形式发货
        handleSubmitDelivery(){
            this.disabled = true
            this.$emit('confirm',this.ruleForm);
            setInterval(()=>{
                this.disabled = false
            },3000)
        },
        // 填写物流单号的形式发货
        handleSubmit(){
            let { logisticsName , logisticsNumber } = this.ruleForm
            let { orderId, tradeId } = this.formData
            let params = {
               opcode: this.$code.DeliveryGoods,
               i_goods_order: tradeId,
               order: orderId,
               v_logistics_name: logisticsName,
               v_logistics_no: logisticsNumber
            }
            // console.log(params)
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    this.$message.success('发货成功')
                    this.$emit('confirm');
                    this.closeDialog();      
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        closeDialog(){
            this.resetForm()
            this.$emit('close');
        },
        handleClose(){
            this.resetForm()
            this.$emit('close');
        },
        close(){
            this.isShowAddress = false
        },
        resetForm(){
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            } else {
                console.error('表单组件未找到');
            }
        },
        getAddress(){
            let params = {
                opcode: 121
            }
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    let arr= res.Data.DataTable
                    if(arr.length > 0){                    
                        let addressArr = arr.map(item=>{
                            return{
                                id: item['地址序号'],
                                district: item['县（区）'],
                                city: item['市'],
                                province: item['省'],
                                phone: item['收货人电话'],
                                name: item['收货人'],
                                des: item['详细地址'],
                                isDefault: item['是否默认地址'],
                                senderAddress:item['省']+''+item['市']+''+item['县（区）']+''+ item['详细地址']
                            }
                        })
                        this.addressOption  = addressArr
                        let useAddress = addressArr.filter((i)=>i.isDefault === '0')
                        // console.log(useAddress)
                        let {name,phone,province,city,district, des} = useAddress[0]
                        this.ruleForm.senderAddress = province +''+ city +''+ district +''+ des
                        this.ruleForm.senderName = name
                        this.ruleForm.senderPhone = phone
                    }else{
                        this.errMsg = '暂无发货地址，请先去添加发件人地址'
                        // this.$message.error('暂无发货地址，请先去添加发件人地址')
                    }
                }
            })
        },
        selectSenderAddress(row){
            // console.log(row)
            this.ruleForm.senderName = row.name
            this.ruleForm.senderPhone = row.phone
            this.ruleForm.senderAddress = row.senderAddress
            // console.log(this.ruleForm)
        },
        changeReserveDate(){
            this.ruleForm.reserveTime = ''
        }
    },
}
</script>
<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/views/product/components/deliveryDialog.vue